// extracted by mini-css-extract-plugin
export var label = "_di-1";
export var reminder = "_di-0";